/**
 * @generated SignedSource<<677af52ecfd5313cfd5c9b94d08011cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useIsOlympicArticle$data = {
  readonly sections: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "useIsOlympicArticle";
};
export type useIsOlympicArticle$key = {
  readonly " $data"?: useIsOlympicArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"useIsOlympicArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "useIsOlympicArticle"
};

(node as any).hash = "fa7803e68b3740b4b59a6637aa97b608";

export default node;
